import { Context } from "@nuxt/types/app";
import formatCurrency from "format-currency";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function currencyFilterRp(val: null | string | number): string {
    if (val === null) return "-";
    return formatCurrency(val, {
      symbol: "Rp ",
      format: "%s%v",
      locale: "id",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  return {
    currencyFilterRp,
  };
}
